import React from "react";
import { Typography, Layout, Grid } from "antd";
import HeaderBar from "../components/common/CommonHeader";
import FooterBar from "../components/common/CommonFooter";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;
const { useBreakpoint } = Grid;

const CookiePolicy = () => {
  const screens = useBreakpoint();

  return (
    <Layout style={{ background: "#fff" }}>
      <div>
        <HeaderBar bgColor="#DDC7BB" />
      </div>

      <Content
        style={{
          padding: screens.xs
            ? "30px 20px"
            : screens.md
            ? "40px 40px"
            : "60px 80px",
          maxWidth: 1000,
          margin: "0 auto",
          width: "100%",
        }}
        data-aos="fade-up"
      >
        {/* Header Title Box */}
        <div
          style={{
            height: screens.xs ? "40px" : "50px",
            width: screens.xs ? "250px" : "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: screens.xs ? "10px auto" : "20px auto",
            borderRadius: "20px",
            padding: screens.xs ? "15px" : "20px",
          }}
          data-aos="fade-up"
        >
          <Title
            level={screens.xs ? 3 : 2}
            style={{
              margin: 0,
              fontSize: screens.xs ? "20px" : "28px",
            }}
          >
            Cookie Policy
          </Title>
        </div>

        <Typography data-aos="fade-up">
          <Paragraph style={{ fontSize: screens.xs ? "14px" : "16px" }}>
            <Text strong>Effective Date:</Text> October 23, 2025
          </Paragraph>

          <Paragraph
            style={{ fontSize: screens.xs ? "14px" : "16px", lineHeight: 1.6 }}
          >
            This Cookie Policy explains how{" "}
            <Text strong>Not in the Market</Text> (“we,” “our,” or “us”) uses
            cookies and similar technologies on our website to enhance your
            experience, analyze performance, and support property transactions.
          </Paragraph>

          <Title
            level={screens.xs ? 5 : 4}
            style={{ marginTop: screens.xs ? "20px" : "24px" }}
          >
            1. What Are Cookies?
          </Title>
          <Paragraph
            style={{ fontSize: screens.xs ? "14px" : "16px", lineHeight: 1.6 }}
          >
            Cookies are small text files stored on your device when you visit a
            website. They help us remember your preferences, improve
            functionality, and deliver relevant content.
          </Paragraph>

          <Title
            level={screens.xs ? 5 : 4}
            style={{ marginTop: screens.xs ? "20px" : "24px" }}
          >
            2. Why We Use Cookies
          </Title>
          <Paragraph style={{ fontSize: screens.xs ? "14px" : "16px" }}>
            We use cookies to:
          </Paragraph>
          <ul
            style={{
              fontSize: screens.xs ? "14px" : "16px",
              paddingLeft: screens.xs ? "20px" : "24px",
              lineHeight: 1.6,
            }}
          >
            <li>Enable secure login and navigation</li>
            <li>Analyze site performance and user behavior</li>
            <li>Remember user preferences (e.g. filters, saved listings)</li>
            <li>Deliver targeted ads and remarketing campaigns</li>
            <li>
              Support third-party features like embedded maps, videos, and chat
              tools
            </li>
          </ul>

          <Title
            level={screens.xs ? 5 : 4}
            style={{ marginTop: screens.xs ? "20px" : "24px" }}
          >
            3. Types of Cookies We Use
          </Title>
          <div style={{ overflowX: "auto", marginBottom: "20px" }}>
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
                minWidth: screens.xs ? "500px" : "100%",
                marginBottom: "20px",
                border: "1px solid #ddd",
                fontSize: screens.xs ? "12px" : "14px",
              }}
              data-aos="fade-up"
            >
              <thead style={{ backgroundColor: "#f7f7f7" }}>
                <tr>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                      textAlign: "left",
                    }}
                  >
                    Type
                  </th>
                  <th
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                      textAlign: "left",
                    }}
                  >
                    Purpose
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Essential Cookies
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Required for core site functions like login, navigation, and
                    security.
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Performance Cookies
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Help us understand how users interact with the site (e.g.
                    Google Analytics, Hotjar).
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Functionality Cookies
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Remember your settings and preferences.
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Advertising / Targeting Cookies
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Used for remarketing and ad personalization (e.g. Facebook
                    Pixel, Google Ads).
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Third-Party Cookies
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: screens.xs ? "6px" : "8px",
                    }}
                  >
                    Enable features from external services (e.g. embedded
                    videos, maps, chat widgets).
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <Title
            level={screens.xs ? 5 : 4}
            style={{ marginTop: screens.xs ? "20px" : "24px" }}
          >
            4. Consent & Control
          </Title>
          <Paragraph
            style={{ fontSize: screens.xs ? "14px" : "16px", lineHeight: 1.6 }}
          >
            Currently, we do not use a cookie banner or consent mechanism. By
            continuing to use our site, you agree to our use of cookies as
            described in this policy.
          </Paragraph>
          <Paragraph
            style={{ fontSize: screens.xs ? "14px" : "16px", lineHeight: 1.6 }}
          >
            We are working toward implementing a consent system to comply with
            GDPR and ePrivacy standards.
          </Paragraph>

          <Title
            level={screens.xs ? 5 : 4}
            style={{ marginTop: screens.xs ? "20px" : "24px" }}
          >
            5. Data Sharing
          </Title>
          <Paragraph
            style={{ fontSize: screens.xs ? "14px" : "16px", lineHeight: 1.6 }}
          >
            We do not share cookie data with third parties at this time.
            However, some third-party services may collect data independently
            when embedded on our site.
          </Paragraph>

          <Title
            level={screens.xs ? 5 : 4}
            style={{ marginTop: screens.xs ? "20px" : "24px" }}
          >
            6. Cross-Site Tracking
          </Title>
          <Paragraph
            style={{ fontSize: screens.xs ? "14px" : "16px", lineHeight: 1.6 }}
          >
            We use cookies for cross-site tracking and remarketing to deliver
            relevant property ads and updates across platforms.
          </Paragraph>

          <Title
            level={screens.xs ? 5 : 4}
            style={{ marginTop: screens.xs ? "20px" : "24px" }}
          >
            7. Cookie Duration
          </Title>
          <Paragraph
            style={{ fontSize: screens.xs ? "14px" : "16px", lineHeight: 1.6 }}
          >
            All cookies used on our site are session-based, meaning they expire
            when you close your browser.
          </Paragraph>

          <Title
            level={screens.xs ? 5 : 4}
            style={{ marginTop: screens.xs ? "20px" : "24px" }}
          >
            8. Your Rights
          </Title>
          <Paragraph
            style={{ fontSize: screens.xs ? "14px" : "16px", lineHeight: 1.6 }}
          >
            If you are located in the European Union or other regions with
            privacy laws, you have the right to:
          </Paragraph>
          <ul
            style={{
              fontSize: screens.xs ? "14px" : "16px",
              paddingLeft: screens.xs ? "20px" : "24px",
              lineHeight: 1.6,
              marginBottom: screens.xs ? "20px" : "24px",
            }}
          >
            <li>Access your personal data</li>
            <li>Request deletion or correction</li>
            <li>Withdraw consent (once a consent mechanism is implemented)</li>
          </ul>

          <Paragraph
            style={{ fontSize: screens.xs ? "14px" : "16px", lineHeight: 1.6 }}
          >
            For more information, please review our Privacy Policy or contact us
            at <Text strong>privacy@notinthemarket.com</Text>.
          </Paragraph>
        </Typography>
      </Content>

      <div data-aos="fade-up">
        <FooterBar />
      </div>
    </Layout>
  );
};

export default CookiePolicy;
